import { css } from 'styled-components';

export const customScrollbarMixin = css`
  scrollbar-width: thin;
  scrollbar-color: rgba(17, 17, 17, 0.3) transparent;

  &::-webkit-scrollbar {
    background-color: transparent;
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(17, 17, 17, 0.3);
    border-radius: 6px;

    &:hover {
      background-color: rgba(17, 17, 17, 0.3);
    }
  }
`;
